import React, { Component } from "react";
import PropTypes from "prop-types";

import { Card, Form, Button, Input, message, Select } from "antd";
import { connect } from "react-redux";
import storageUtils from "../../utils/storageUtils";
import {
  req_add_smscontent,
  req_edit_smscontent,
  req_single_people,
} from "../../api";

const Item = Form.Item;

class NewsEditModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    news: PropTypes.object,
  };

  state = {
    isUpdate: false,
    isInsert: false,
    nowWeek: 0,
    selectedWeek: 1,
    weeks: [
      { label: "第01週", value: "1" },
      { label: "第02週", value: "2" },
      { label: "第03週", value: "3" },
      { label: "第04週", value: "4" },
      { label: "第05週", value: "5" },
      { label: "第06週", value: "6" },
      { label: "第07週", value: "7" },
      { label: "第08週", value: "8" },
      { label: "第09週", value: "9" },
      { label: "第10週", value: "10" },
      { label: "第11週", value: "11" },
      { label: "第12週", value: "12" },
      { label: "第13週", value: "13" },
      { label: "第14週", value: "14" },
      { label: "第15週", value: "15" },
      { label: "第16週", value: "16" },
      { label: "第17週", value: "17" },
      { label: "第18週", value: "18" },
      { label: "第19週", value: "19" },
      { label: "第20週", value: "20" },
      { label: "第21週", value: "21" },
      { label: "第22週", value: "22" },
      { label: "第23週", value: "23" },
      { label: "第24週", value: "24" },
      { label: "第25週", value: "25" },
      { label: "第26週", value: "26" },
      { label: "第27週", value: "27" },
      { label: "第28週", value: "28" },
      { label: "第29週", value: "29" },
      { label: "第30週", value: "30" },
      { label: "第31週", value: "31" },
      { label: "第32週", value: "32" },
      { label: "第33週", value: "33" },
      { label: "第34週", value: "34" },
      { label: "第35週", value: "35" },
      { label: "第36週", value: "36" },
      { label: "第37週", value: "37" },
      { label: "第38週", value: "38" },
      { label: "第39週", value: "39" },
      { label: "第40週", value: "40" },
      { label: "第41週", value: "41" },
      { label: "第42週", value: "42" },
      { label: "第43週", value: "43" },
      { label: "第44週", value: "44" },
      { label: "第45週", value: "45" },
      { label: "第46週", value: "46" },
      { label: "第47週", value: "47" },
      { label: "第48週", value: "48" },
      { label: "第49週", value: "49" },
      { label: "第50週", value: "50" },
      { label: "第51週", value: "51" },
      { label: "第52週", value: "52" },
    ],
    selectedCategory: "一般公告",
    category: [
      { label: "一般公告", value: "一般公告" },
      { label: "媒體報導", value: "媒體報導" },
      { label: "各式展演", value: "各式展演" },
      { label: "活動報名", value: "活動報名" },
      { label: "演講研討會", value: "演講研討會" },
      { label: "多元競賽", value: "多元競賽" },
      { label: "競賽獲獎", value: "競賽獲獎" },
      { label: "考試資訊", value: "考試資訊" },
      { label: "招生公告", value: "招生公告" },
      { label: "媒體報導", value: "媒體報導" },
      { label: "獎助學金", value: "獎助學金" },
      { label: "實習工讀", value: "實習工讀" },
      { label: "職缺公告", value: "職缺公告" },
      { label: "榜單公告", value: "榜單公告" },
      { label: "捐贈興學", value: "捐贈興學" },
      { label: "徵稿徵圖", value: "徵稿徵圖" },
      { label: "抽獎活動", value: "抽獎活動" },
      { label: "中獎通知", value: "中獎通知" },
      { label: "師生優惠", value: "師生優惠" },
    ],
    item: {
      Uid: "",
      DepartmentCode: "",
      DepartmentTwName: "",
      DataCategory: "一般公告",
      DataContent: "",
      DataUrl: "",
      SendMailWeekNum: "",
      RecordCreatorCode: "",
      RecordCreatorName: "",
    },
    user: {},
  };

  UNSAFE_componentWillMount() {
    this.init();
  }

  componentDidMount() {}

  // 遠端數據處理 //////////////////////////////////////////////

  api_user_data = async () => {
    const user = await req_single_people(
      storageUtils.getUser().userCode,
      storageUtils.getUser().token
    );
    if (user) {
      this.setState({ user });
    }
  };

  api_modify_item = async (item) => {
    const { isUpdate } = this.state;
    // console.log(item);
    if (isUpdate) {
      // const { uid } = this.props.bulletinBoard;
      // item.uid = uid;
      // console.log(applycase)
      const result = await req_edit_smscontent(
        item,
        storageUtils.getUser().token
      );
      if (result.status === "success") {
        // console.log(result)
        message.success(result.message);
      } else {
        message.error(result.message);
      }
    } else {
      const result = await req_add_smscontent(
        item,
        storageUtils.getUser().token
      );
      if (result.status === "success") {
        message.success(result.message);
      } else {
        message.error(result.message);
      }
    }
  };

  // 數據配置設定 //////////////////////////////////////////////
  getYearWeek = (year, month, day) => {
    var nowDay = new Date(year, month - 1, day);
    var firstYearDay = new Date(year, 0, 1);
    var nowYearDay = Math.ceil((nowDay - firstYearDay) / (24 * 60 * 60 * 1000));
    return Math.ceil((nowYearDay + (firstYearDay.getDay() + 1 - 1)) / 7);
  };
  init = () => {
    // console.log("init");
    const { SendMailWeekNum, DataCategory } = this.props.news;
    const { weeks } = this.state;
    const currentdate = new Date();
    const nowWeek =
      this.getYearWeek(
        currentdate.getFullYear(),
        currentdate.getMonth() + 1,
        currentdate.getDate()
      ) + 1;
    var weekSelect = [];
    weeks.forEach((element) => {
      if (element.value > nowWeek) {
        weekSelect.push(element);
      }
    });
    this.setState({
      nowWeek,
      weeks: weekSelect,
      selectedWeek: SendMailWeekNum,
      selectedCategory: DataCategory,
    });

    if (this.props.news) {
      const item = this.props.news;
      this.setState({ item, isUpdate: true });
    }
    this.api_user_data();
  };

  // 操作互動處理 //////////////////////////////////////////////
  handleWeekChange = (value) => {
    console.log(value);
    this.setState({ selectedWeek: value });
  };

  handleCategoryChange = (value) => {
    console.log(value);
    this.setState({ selectedCategory: value });
  };

  onFinish = (values) => {
    // console.log("Success:", values);
    const { DataContent, DataUrl } = values;
    const { userCode, userName } = storageUtils.getUser();
    const { selectedWeek, selectedCategory } = this.state;
    const { DeptmentRealCode, DepartmentTwName } = this.state.user;
    const news = {
      Uid: this.state.item.Uid,
      DepartmentCode: DeptmentRealCode,
      DepartmentTwName: DepartmentTwName,
      DataCategory: selectedCategory,
      DataContent: DataContent,
      DataUrl: DataUrl,
      SendMailWeekNum: selectedWeek,
      RecordCreatorCode: userCode,
      RecordCreatorName: userName,
      condition: "BASE",
    };
    //console.log(news);
    this.api_modify_item(news);
  };

  ///////////////////////////////////////////////////////////

  render() {
    const { isUpdate, weeks, selectedWeek, category } = this.state;
    const { DataContent, DataCategory, DataUrl } = this.state.item;
    return (
      <Card>
        <Form onFinish={this.onFinish}>
          <Item label="寄發週別">
            <Select
              defaultValue={"第" + selectedWeek + "週"}
              onChange={this.handleWeekChange}
              style={{
                width: 120,
              }}
              options={weeks}
            />
          </Item>
          <Item label="內容分類">
            <Select
              defaultValue={DataCategory}
              onChange={this.handleCategoryChange}
              style={{
                width: 120,
              }}
              options={category}
            />
          </Item>
          <Item
            label="主旨內容"
            name="DataContent"
            initialValue={DataContent}
            rules={[
              { required: true, whitespace: true, message: "必須填寫內容" },
            ]}
          >
            <Input placeholder="輸入主旨內容" />
          </Item>
          <Item
            label="外部網址"
            name="DataUrl"
            initialValue={DataUrl}
            rules={[
              { whitespace: true },
              {
                type: "url",
                message: "請輸入正確的外部網址",
              },
            ]}
          >
            <Input placeholder="相關內容網址(非必填)" />
          </Item>
          <Item>
            <Button type="primary" htmlType="submit" className="wave" block>
              {isUpdate ? "修改" : "送出"}
            </Button>
          </Item>
        </Form>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(NewsEditModal);
